import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { changePassword } from '../api';

function Login() {
  const { login, refreshUser } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Étape « mot de passe provisoire » après le premier login
  const [mustChange, setMustChange] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');

  const redirectByRole = (user) => {
    navigate(user.role === 'superadmin' ? '/admin' : '/', { replace: true });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const user = await login(email, password);
      if (user.must_change_password) {
        setMustChange(true);
      } else {
        redirectByRole(user);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setSubmitting(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== newPassword2) {
      setError('Les deux mots de passe ne correspondent pas');
      return;
    }
    setSubmitting(true);
    try {
      await changePassword(password, newPassword);
      await refreshUser();
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors du changement de mot de passe');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <img src="/e-facture.png" alt="E-facture" style={{ height: 80, width: 'auto' }} />
        </div>

        {!mustChange ? (
          <>
            <h2>Connexion</h2>
            <p className="login-subtitle">Accédez à votre espace de facturation</p>
            {error && <div className="alert alert-error">{error}</div>}
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="vous@entreprise.fr"
                />
              </div>
              <div className="form-group">
                <label>Mot de passe</label>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>
              <button type="submit" className="btn btn-primary login-submit" disabled={submitting}>
                {submitting ? 'Connexion...' : 'Se connecter'}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2>Définir votre mot de passe</h2>
            <p className="login-subtitle">
              Votre mot de passe provisoire doit être remplacé avant de continuer.
            </p>
            {error && <div className="alert alert-error">{error}</div>}
            <form onSubmit={handleChangePassword}>
              <div className="form-group">
                <label>Nouveau mot de passe</label>
                <input
                  type="password"
                  required
                  minLength={8}
                  autoFocus
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="8 caractères minimum"
                />
              </div>
              <div className="form-group">
                <label>Confirmer le mot de passe</label>
                <input
                  type="password"
                  required
                  minLength={8}
                  value={newPassword2}
                  onChange={(e) => setNewPassword2(e.target.value)}
                />
              </div>
              <button type="submit" className="btn btn-primary login-submit" disabled={submitting}>
                {submitting ? 'Enregistrement...' : 'Enregistrer et continuer'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default Login;
